"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/ui/button";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { ArrowLeftIcon, HomeIcon } from "lucide-react";
export default function NotFoundUi() {
  const $ = _c(9);
  const router = useRouter();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="font-mono text-7xl font-bold tracking-tighter sm:text-8xl">404</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex flex-col items-center gap-2"><h1 className="text-2xl font-bold tracking-tight sm:text-3xl">Page not found</h1><p className="text-muted-foreground max-w-md text-sm">The page you are looking for does not exist or has been moved. Check the URL, or head back to safety.</p></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Link href="/" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Button render={t2} nativeButton={false} className="w-full sm:w-auto"><HomeIcon data-icon="inline-start" aria-hidden="true" />Go Home</Button>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== router) {
    t4 = () => router.back();
    $[4] = router;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ArrowLeftIcon data-icon="inline-start" aria-hidden="true" />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4) {
    t6 = <section className="bg-background text-foreground flex min-h-svh w-full flex-col items-center justify-center gap-6 px-6 py-12 text-center">{t0}{t1}<div className="flex flex-col items-center gap-2 sm:flex-row">{t3}<Button variant="outline" onClick={t4} className="w-full sm:w-auto">{t5}Go Back</Button></div></section>;
    $[7] = t4;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}